import React from "react";
import "./auth-screen.css";

/****************************************************
 * ##: Login failed screen
 * Shown when the Auth0 login round-trip completes without a session (the gate's loginStatus is
 * completed and not success), most often a transient failure: an Auth0 blip, a dropped token
 * exchange, a flaky network. Uses the shared auth-screen chrome (auth-screen.css, asc-) with the
 * error tile; its only own markup is the key glyph and the two recovery actions (clear the session on
 * the left, the primary retry on the right), with support in the foot. Sibling of the
 * session-superseded screen, which shares the same chrome.
 * @param {Object} props - { onLogout, onRetry }
 * @returns {JSX.Element} - The login failed status screen
 * History:
 * 26-10-2026: Created
 ****************************************************/

const SUPPORT_URL = "https://ajuda.salespark.io";

// Inline glyph (currentColor), so the screen stays plain HTML like its sibling. A key: this is about
// signing in, told apart from the superseded screen's padlock (locked out by another session).
const KeyGlyph = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M2.586 17.414A2 2 0 0 0 2 18.828V21a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h.172a2 2 0 0 0 1.414-.586l.814-.814a6.5 6.5 0 1 0-4-4z" />
    <circle cx="16.5" cy="7.5" r="0.6" fill="currentColor" stroke="none" />
  </svg>
);

const Auth0LoginFailedScreen = ({ onLogout, onRetry }) => {
  return (
    <div className="asc-page">
      <div className="asc-shell">
        <div className="asc-panel">
          <img className="asc-brand" src="/img/logo_grey.svg" alt="SalesPark" />

          <div className="asc-head">
            <div className="asc-tile asc-tile--error">
              <KeyGlyph />
            </div>
            <div>
              <h1 className="asc-title">Não foi possível iniciar sessão</h1>
              <p className="asc-sub">Pode ser uma falha temporária. Espera um momento e tenta novamente.</p>
            </div>
          </div>

          <div className="asc-actions">
            <button type="button" className="sp-btn sp-btn-neutral" onClick={onLogout}>
              Limpar sessão e sair
            </button>
            <button type="button" className="sp-btn" onClick={onRetry}>
              Tentar novamente
            </button>
          </div>

          <hr className="asc-rule" />

          <div className="asc-foot">
            <span>Precisas de ajuda?</span>
            <a href={SUPPORT_URL} target="_blank" rel="noreferrer">
              Contacta o suporte
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Auth0LoginFailedScreen;
